import * as React from "react";

function constacts(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 453 365" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M213.25 102.647c-.146-2.073 1.446-3.874 3.558-4.023l12.614-.891c2.111-.15 3.941 1.41 4.087 3.482l15.803 223.632c.146 2.073-1.447 3.873-3.558 4.023l-4.013.283-8.601.608c-2.111.149-3.941-1.41-4.087-3.482L213.25 102.647z"
        fill="url(#prefix__paint0_linear_101:104)"
      />
      <path
        d="M242.758 354.843c-.331 1.459-2.466 1.61-2.999.212l-10.572-27.747c-.352-.925.329-1.918 1.366-1.992l17.138-1.211c1.036-.073 1.851.815 1.632 1.78l-6.565 28.958z"
        fill="url(#prefix__paint1_linear_101:104)"
      />
      <path
        d="M213.223 102.261a3.38 3.38 0 013.139-3.605l13.506-.955a3.38 3.38 0 013.614 3.129l1.216 17.208a3.38 3.38 0 01-3.139 3.606l-13.506.954a3.38 3.38 0 01-3.614-3.128l-1.216-17.209z"
        fill="url(#prefix__paint2_linear_101:104)"
      />
      <path
        d="M213.475 118.921c-.06-.853.562-1.592 1.389-1.65l19.104-1.35c.828-.059 1.547.585 1.608 1.438l1.473 20.854c.06.853-.562 1.592-1.389 1.65l-19.104 1.35c-.828.059-1.547-.586-1.608-1.439l-1.473-20.853z"
        fill="url(#prefix__paint3_linear_101:104)"
      />
      <path
        d="M280.36 43.704c.823-8.023 7.993-13.86 16.016-13.037L438.224 45.21c8.023.823 13.86 7.993 13.037 16.016L422.436 342.36c-.823 8.022-7.994 13.859-16.016 13.037l-141.848-14.545c-8.023-.822-13.86-7.993-13.038-16.016L280.36 43.704z"
        fill="url(#prefix__paint4_linear_101:104)"
      />
      <path
        d="M283.559 46.19c.775-7.551 7.523-13.045 15.074-12.27l37.064 3.8a4.616 4.616 0 014.122 5.064 4.618 4.618 0 004.123 5.064l44.861 4.6a4.617 4.617 0 005.064-4.123 4.617 4.617 0 015.064-4.122l36.423 3.735c7.551.774 13.045 7.523 12.27 15.074l-28.387 276.86c-.775 7.551-7.523 13.044-15.074 12.27l-136.721-14.019c-7.551-.774-13.045-7.523-12.27-15.073l28.387-276.86z"
        fill="#fff"
      />
      <path
        d="M261.129 264.943l176.025-99.817-14.259 139.07-66.157 43.084-89.296-9.156c-10.446-1.287-12.73-10.588-12.314-14.647l6.001-58.534zM275.761 122.241l137.162-76.603 22.858 2.344c6.966.714 12.176 7.311 11.931 14.175 0 0-3.658 36.034-5.542 54.048L265.839 219.013l9.922-96.772z"
        fill="#D2E3FD"
        fillOpacity={0.3}
      />
      <path
        d="M390.076 47.398a1.932 1.932 0 11-3.844-.393 1.932 1.932 0 013.844.392zM355.042 43.805a1.933 1.933 0 11-3.846-.394 1.933 1.933 0 013.846.394zM381.959 46.566a1.074 1.074 0 11-2.136-.219 1.074 1.074 0 012.136.219zM346.924 42.973a1.933 1.933 0 11-3.846-.395 1.933 1.933 0 013.846.395z"
        fill="#404040"
      />
      <path
        d="M359.38 43.602a1.288 1.288 0 011.413-1.15l13.672 1.402a1.29 1.29 0 011.151 1.413l-.132 1.282a1.288 1.288 0 01-1.413 1.15l-13.672-1.402a1.288 1.288 0 01-1.15-1.413l.131-1.282z"
        fill="#fff"
      />
      <g filter="url(#prefix__filter0_d_101:104)">
        <path
          d="M298.701 109.05c1.21-11.798 11.755-20.382 23.553-19.172l80.324 8.236c11.798 1.21 20.382 11.755 19.172 23.553l-9.156 89.296c-1.21 11.798-11.755 20.382-23.553 19.172l-80.324-8.236c-11.798-1.21-20.381-11.755-19.172-23.553l9.156-89.296z"
          fill="#D2E3FD"
        />
        <path
          d="M308.136 181.256a4.724 4.724 0 015.181-4.218l80.324 8.236a4.724 4.724 0 11-.964 9.4l-80.323-8.236a4.725 4.725 0 01-4.218-5.182zM306.69 195.355a4.724 4.724 0 015.182-4.218l46.143 4.731a4.725 4.725 0 01-.964 9.4l-46.143-4.731a4.724 4.724 0 01-4.218-5.182z"
          fill="#fff"
        />
        <path
          d="M385.368 143.841c-1.572 15.338-15.281 26.497-30.618 24.924-15.338-1.573-26.497-15.281-24.924-30.619 1.572-15.338 15.281-26.497 30.619-24.924 15.337 1.573 26.496 15.281 24.923 30.619z"
          fill="#C7BCFD"
        />
        <path
          d="M342.334 145.824c-.453-12.423 4.969-23.018 16.867-22.583l1.069.109c3.845.395 16.604 2.728 12.183 25.587 0 0-9.372 1.865-15.454 1.21-6.176-.666-14.665-4.323-14.665-4.323z"
          fill="url(#prefix__paint5_linear_101:104)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.107 128.936c.631 2.889 2.63 7.977 6.914 10.779l.074.731c-.158 1.538-.895 1.707-1.244 1.599-1.792 5.688-6.187 7.713-8.161 8.014l-.241 2.35 1.665.603.488 1.561-.198 1.922-1.67 1.556-3.654-.159c-1.053-.252-3.203-.76-3.374-.778-.107-.01-.479-.588-.852-1.166-.372-.578-.745-1.156-.852-1.167-.17-.017.031-1.004.154-1.495l1.108-1.189 1.631-.257.24-2.35c-4.225-2.854-5.381-7.214-5.464-9.413 9.736-.841 12.803-7.264 13.223-11.163l.213.022z"
          fill="url(#prefix__paint6_linear_101:104)"
        />
        <path
          d="M338.678 161.289c1.512-3.515 6.597-10.081 13.586-9.192-.381 1.616.493 4.736 3.793 5.077 4.102.421 5.103-2.502 5.057-4.162 7.024.547 10.123 7.946 10.89 11.694-6.284 4.019-14.121 4.381-17.254 4.06-3.134-.322-10.734-2.267-16.072-7.477z"
          fill="url(#prefix__paint7_linear_101:104)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M372.414 280.213a1.289 1.289 0 001.813.186l6.066-4.938 4.938 6.066a1.289 1.289 0 001.999-1.626l-4.938-6.067a2.578 2.578 0 00-3.626-.372L372.6 278.4a1.289 1.289 0 00-.186 1.813z"
        fill="#D2E3FD"
      />
      <g filter="url(#prefix__filter1_d_101:104)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M297.299 282.213a1.289 1.289 0 001.813.186l6.066-4.938 4.939 6.067a1.288 1.288 0 001.998-1.627l-4.938-6.067a2.577 2.577 0 00-3.625-.372l-6.067 4.939a1.288 1.288 0 00-.186 1.812z"
          fill="#E9879A"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M373.553 269.104a1.288 1.288 0 001.813.186l6.066-4.938 4.939 6.067a1.288 1.288 0 101.998-1.627l-4.938-6.067a2.577 2.577 0 00-3.626-.371l-6.066 4.938a1.288 1.288 0 00-.186 1.812z"
        fill="#D2E3FD"
      />
      <g filter="url(#prefix__filter2_d_101:104)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M298.414 272.104a1.288 1.288 0 001.813.186l6.066-4.938 4.938 6.067a1.289 1.289 0 001.999-1.627l-4.938-6.067a2.577 2.577 0 00-3.626-.371l-6.066 4.938a1.288 1.288 0 00-.186 1.812z"
          fill="#E9879A"
        />
      </g>
      <path
        d="M390.238 314.05c-.896 8.731-8.699 15.083-17.43 14.188-8.73-.896-15.082-8.699-14.187-17.43.895-8.73 8.698-15.082 17.429-14.187 8.731.895 15.083 8.698 14.188 17.429z"
        fill="#D2E3FD"
      />
      <g filter="url(#prefix__filter3_d_101:104)">
        <path
          d="M318.238 305.895c-.896 8.731-8.699 15.083-17.43 14.187-8.73-.895-15.082-8.698-14.187-17.429.895-8.731 8.698-15.083 17.429-14.187 8.731.895 15.083 8.698 14.188 17.429z"
          fill="#E9879A"
        />
      </g>
      <path
        d="M58.29 172.539c1.582-3.888 6.027-5.753 9.926-4.166l166.64 67.847c3.9 1.588 5.778 6.027 4.194 9.915L196.628 350.33c-1.583 3.889-6.028 5.754-9.928 4.166L20.061 286.649c-3.9-1.587-5.778-6.027-4.195-9.915L58.29 172.539z"
        fill="url(#prefix__paint8_linear_101:104)"
      />
      <g filter="url(#prefix__filter4_d_101:104)">
        <path
          d="M129.902 245.404a5.152 5.152 0 015.889 2.398l55.597 97.363c2.427 4.25-1.883 9.172-6.415 7.326L21.581 285.968c-4.532-1.846-4.178-8.378.527-9.724l107.794-30.84z"
          fill="url(#prefix__paint9_linear_101:104)"
        />
      </g>
      <g filter="url(#prefix__filter5_d_101:104)">
        <path
          d="M123.899 277.01a5.152 5.152 0 01-5.889-2.398l-55.597-97.363c-2.427-4.249 1.883-9.171 6.415-7.326l163.392 66.524c4.532 1.845 4.178 8.378-.527 9.724L123.899 277.01z"
          fill="url(#prefix__paint10_linear_101:104)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.54 113.005a2.686 2.686 0 100-5.373 2.686 2.686 0 000 5.373zm0 .806a3.492 3.492 0 10-.001-6.985 3.492 3.492 0 000 6.985zM166.972 6.178a2.686 2.686 0 100-5.373 2.686 2.686 0 000 5.373zm0 .806a3.492 3.492 0 100-6.984 3.492 3.492 0 000 6.984z"
        fill="#D26379"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.756 195.036c2.098 0 3.8-1.787 3.8-3.99 0-2.204-1.702-3.99-3.8-3.99-2.099 0-3.8 1.786-3.8 3.99 0 2.203 1.701 3.99 3.8 3.99zm0 1.651c2.967 0 5.372-2.526 5.372-5.641s-2.405-5.641-5.372-5.641-5.373 2.526-5.373 5.641 2.406 5.641 5.373 5.641zM124.057 169.534c2.456 0 4.446-2.157 4.446-4.817s-1.99-4.817-4.446-4.817c-2.456 0-4.446 2.157-4.446 4.817s1.99 4.817 4.446 4.817zm0 1.993c3.472 0 6.286-3.049 6.286-6.81 0-3.761-2.814-6.81-6.286-6.81-3.472 0-6.286 3.049-6.286 6.81 0 3.761 2.814 6.81 6.286 6.81zM59.233 48.946a3.8 3.8 0 100-7.6 3.8 3.8 0 000 7.6zm0 1.572a5.372 5.372 0 100-10.744 5.372 5.372 0 000 10.744zM237.343 61.977c2.099 0 3.8-1.786 3.8-3.99s-1.701-3.99-3.8-3.99c-2.099 0-3.8 1.786-3.8 3.99s1.701 3.99 3.8 3.99zm0 1.65c2.967 0 5.372-2.525 5.372-5.64 0-3.115-2.405-5.64-5.372-5.64s-5.372 2.525-5.372 5.64c0 3.115 2.405 5.64 5.372 5.64z"
        fill="#7053D2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.841 207.871c1.483 0 2.686-1.11 2.686-2.479 0-1.37-1.203-2.48-2.686-2.48-1.484 0-2.686 1.11-2.686 2.48 0 1.369 1.202 2.479 2.686 2.479zm0 .744c1.928 0 3.492-1.443 3.492-3.223 0-1.781-1.564-3.224-3.492-3.224-1.929 0-3.492 1.443-3.492 3.224 0 1.78 1.563 3.223 3.492 3.223zM143.439 93.23a6.044 6.044 0 10.001-12.088 6.044 6.044 0 00-.001 12.089zm0 1.814a7.858 7.858 0 100-15.715 7.858 7.858 0 000 15.715z"
        fill="#D26379"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_101:104"
          x1={216.724}
          y1={151.801}
          x2={236.983}
          y2={150.369}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D26379" />
          <stop offset={1} stopColor="#FFC3CF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_101:104"
          x1={234.479}
          y1={339.431}
          x2={245.983}
          y2={338.618}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.352} stopColor="#C4C4C4" />
          <stop offset={0.748} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_101:104"
          x1={223.405}
          y1={102.294}
          x2={225.163}
          y2={127.171}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAB667" />
          <stop offset={1} stopColor="#FAB667" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear_101:104"
          x1={214.062}
          y1={127.224}
          x2={236.162}
          y2={125.662}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#969696" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear_101:104"
          x1={250.045}
          y1={339.363}
          x2={452.751}
          y2={46.7}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7053D2" />
          <stop offset={1} stopColor="#D2C5FF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear_101:104"
          x1={338.875}
          y1={159.366}
          x2={372.512}
          y2={132.377}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B23850" />
          <stop offset={1} stopColor="#ECA6B4" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear_101:104"
          x1={350.794}
          y1={152.601}
          x2={370.173}
          y2={136.239}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FFE1BE" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear_101:104"
          x1={338.678}
          y1={161.289}
          x2={366.855}
          y2={155.975}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8590AA" />
          <stop offset={1} stopColor="#B3C0E0" />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear_101:104"
          x1={15.683}
          y1={284.867}
          x2={241.791}
          y2={238.48}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FFDFBA" />
        </linearGradient>
        <linearGradient
          id="prefix__paint9_linear_101:104"
          x1={19.369}
          y1={285.067}
          x2={189.189}
          y2={210.875}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9B25F" />
          <stop offset={1} stopColor="#FFDFBA" />
        </linearGradient>
        <linearGradient
          id="prefix__paint10_linear_101:104"
          x1={90.439}
          y1={256.755}
          x2={242.286}
          y2={240.567}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAB564" />
          <stop offset={1} stopColor="#FFE6C9" />
        </linearGradient>
        <filter
          id="prefix__filter0_d_101:104"
          x={269.432}
          y={73.764}
          width={172.432}
          height={180.484}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_101:104" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_101:104" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d_101:104"
          x={287.01}
          y={268.884}
          width={35.395}
          height={29.119}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_101:104" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_101:104" result="shape" />
        </filter>
        <filter
          id="prefix__filter2_d_101:104"
          x={288.125}
          y={258.775}
          width={35.395}
          height={29.119}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_101:104" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_101:104" result="shape" />
        </filter>
        <filter
          id="prefix__filter3_d_101:104"
          x={276.537}
          y={282.382}
          width={51.785}
          height={51.785}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_101:104" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_101:104" result="shape" />
        </filter>
        <filter
          id="prefix__filter4_d_101:104"
          x={0.373}
          y={221.205}
          width={209.715}
          height={143.685}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={-6} />
          <feGaussianBlur stdDeviation={9} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_101:104" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_101:104" result="shape" />
        </filter>
        <filter
          id="prefix__filter5_d_101:104"
          x={44.713}
          y={159.524}
          width={207.715}
          height={141.685}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy={7} />
          <feGaussianBlur stdDeviation={8.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_101:104" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_101:104" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default constacts;
